import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : null,
};

// Authslice is for the localStorage management
const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setCredentials: (state, action) => {
			state.userInfo = action.payload;
			localStorage.setItem('userInfo', JSON.stringify(action.payload));
		},
		logout: (state, action) => {
			// 保存主题相关配置
			const themeConfig = {
				theme: localStorage.getItem('theme'),
				isDark: localStorage.getItem('isDark'),
				isFluid: localStorage.getItem('isFluid'),
				isRTL: localStorage.getItem('isRTL'),
				navbarPosition: localStorage.getItem('navbarPosition'),
				isNavbarVerticalCollapsed: localStorage.getItem('isNavbarVerticalCollapsed'),
				navbarStyle: localStorage.getItem('navbarStyle'),
			};

			// 保存所有用户的指引记录（hasSeenSearchTour_* 格式的键）
			const searchTourRecords = {};
			for (let i = 0; i < localStorage.length; i++) {
				const key = localStorage.key(i);
				if (key && key.startsWith('hasSeenSearchTour_')) {
					searchTourRecords[key] = localStorage.getItem(key);
				}
			}

			// 清除所有 localStorage
			localStorage.clear();

			// 恢复主题相关配置
			Object.entries(themeConfig).forEach(([key, value]) => {
				if (value !== null) {
					localStorage.setItem(key, value);
				}
			});

			// 恢复所有用户的指引记录
			Object.entries(searchTourRecords).forEach(([key, value]) => {
				if (value !== null) {
					localStorage.setItem(key, value);
				}
			});

			state.userInfo = null;
			sessionStorage.removeItem('notificationBannerShownIds');
		},
	},
});

export const { setCredentials, logout } = authSlice.actions;

export default authSlice.reducer;
